export default {
  name: 'Mv',

  data() {
    return {};
  },

  props: ['songComment', 'musicList'],

  mounted() {
    console.log(this.songComment);
    console.log(this.musicList);
  },

  methods: {}
};